export default {
  lang: {
    title: {
      login: '登录',
      quickQuery: '申请记录查询',
      ssoCallback: '请稍候...',
      confirmInfo: '确认个人信息',
      confirmPack: '请选择需要的文件',
      confirmReceiveInfo: '请选择领取方式',
      submit: '提交申请',
      applyList: '申请记录',
      applyDetail: '申请单明细'
    },
    common: {
      chooseDate: '选择日期',
      pleaseSelect: '请选择',
      uploadFile: '上传文件',
      yes: '是',
      no: '否',
      uploadAttachment: '上传附件',
      cny: '人民币',
      usd: '美元',
      goNext: '下一步',
      goBack: '上一步',
      uploadTip: '将文件拖到此处，或点击上传',
      notice: '提示',
      remark: '备注',
      query: '查询',
      confirmUpload: '确认上传',
      warning: '提示',
      back: '返回',
      uploadSuccess: '上传成功'
    },
    toast: {
      serverInternalError: '服务器内部错误，请联系管理员',
      urlNotFound: '请求地址错误，请联系管理员',
      requestError: '请求出错，请联系管理员',
      applyAlreadySubmit: '当前申请单已提交，是否重新提交申请？',
      operationSuccess: '操作成功',
      applyAlreadyCancelled: '当前申请单已作废，请重新申请'
    },
    loginPage: {
      ceibsStudentCert: '成绩单及证明申请系统',
      wantToApply: '我要申请',
      useCeibsAccount: '中欧账号登录',
      quickApply: '忘记中欧账号，由此申请',
      systemNotice: '系统公告',
      applyQuery: '申请记录查询',
      inputYourId: '输入证件号（身份证/护照号）',
      inputApplyNo: '输入申请单号',
      or: '或',
      query: '查询',
      youHaveUnFinishedApply: '您有一个未完成的申请，是否继续申请？',
      login: '登录',
      createNewApply: '提交新申请',
      logout: '退出登录',
      pleaseInputYourIdNo: '请输入您的证件号码',
      pleaseInputYourApplicationNo: '请输入您的申请单号'
    },
    confirmInfo: {
      pleaseConfirmYourInfo: '个人信息',
      name: '姓名',
      email: '电子邮箱',
      studentNo: '学号/入学年份',
      mobile: '手机号',
      birthday: '出生日期',
      idType: '证件类型',
      gender: '性别',
      idNo: '证件号码',
      passportNo: '证件号码',
      course: '就读课程',
      currentStatus: '目前状态',
      applyType: '申请类型',
      applyPurpose: '申请目的',
      idPhoto: '证件扫描件/照片',
      idTypes: {
        idCard: '身份证',
        passport: '护照'
      },
      genders: {
        male: '男',
        female: '女'
      },
      applyTypes: {
        paper: '纸质版',
        electronic: '电子版'
      },
      upload: {
        pleaseUploadImage: '请上传图片文件格式(jpg/jpeg/png)',
        btn: '上传',
        previewBtn: '预览'
      },
      validate: {
        name: '请输入姓名',
        email: '请输入电子邮箱',
        studentNo: '请输入学号',
        mobile: '请输入手机号',
        birthday: '请选择出生日期',
        idType: '请选择证件类型',
        idNo: '请输入证件号码',
        gender: '请选择性别',
        courseId: '请选择就读课程',
        studentStatus: '请选择目前状态',
        applyType: '请选择申请类型',
        pleaseUploadIdPhoto: '请上传证件扫描件/照片'
      }
    },
    chooseCert: {
      wantToApply: '我要申请',
      chooseCert: '选择文件与证明',
      choosePackage: '文件装袋',
      totalAmount: '总金额',
      certName: '文件名称',
      needUploadAttachment: '是否需要上传附件',
      amount: '数量',
      price: '单价',
      sumAmount: '金额',
      standardCert: '标准文件',
      nonStandardCert: '非标准文件',
      diplomaCert: '学位文件',
      needElectronicVersion: '需要电子版',
      addPackage: '添加文件袋',
      removePackage: '删除文件袋',
      needSeal: '成绩单需密封',
      package: '文件袋',
      certType: '文件类型',
      remainCopyNumber: '剩余可添加数量',
      confirmDeletePackage: '确认删除文件袋',
      sealCharge: '密封费用：CNY ',
      validate: {
        atLeastOneCert: '请至少选择一份证明文件',
        pleaseUploadAttachmentFor: '请至少上传一份附件：',
        pleaseAssignRemainCopyNumber: '请分配所有文件数量：'
      },
      addPackageTooltip: '如需分开领取或分别寄往多个地址，可添加文件袋'
    },
    confirmReceiveInfo: {
      wantToApply: '我要申请',
      chooseReceiveType: '选择领取方式',
      package: '文件袋',
      receiveType: {
        onsite: '自行领取',
        entrustOnsite: '委托领取',
        expressMail: '快递邮寄'
      },
      expressMailCharge: '费用CNY：',
      detail: '详情',
      expectedReceiveTime: '预计领取时间',
      expectedReceiveTimeTips: '请选择工作日，法定节假日与学院假日不可选择',
      downloadEntrustTemplate: '委托模板下载',
      name: '姓名',
      relation: '与申请人关系',
      phoneNumber: '联系电话',
      mailConsignee: '收件人姓名',
      mailConsigneePhone: '收件人电话',
      mailAreaType: '地址类型',
      mainland: '中国大陆',
      hkMacaoTw: '港澳台地区',
      international: '国际',
      mailArea: '国家/地区',
      city: '城市',
      mailZipCode: '邮编',
      mailAddress: '详细地址',
      needExpedite: '是否加急',
      expediteDesc: {
        part1: '注：加急费',
        part2: '元，（或',
        part3: '美元一次）。一般',
        part4: '个工作日完成，加急',
        part5: '个工作日完成。'
      },
      entrustRemark: '委托人信息非必填项目，填写后方便进行委托人身份核实。',
      certType: '文件类型',
      certName: '文件名称',
      quantity: '数量',
      chargeAmount: '金额',
      validate: {
        pleaseChooseExpectedReceiveTime: '请选择预计领取时间',
        expectedReceiveTimeTooEarly: '预计领取时间早于最早可领取时间：',
        mailConsignee: '请输入收件人姓名',
        mailConsigneePhone: '请输入收件人电话',
        mailAreaType: '请选择地址类型',
        mailArea: '请填写国家/地区',
        mailCity: '请填写城市',
        mailAddress: '请填写详细地址'
      }
    },
    submit: {
      wantToApply: '我要申请',
      submitApply: '提交申请',
      sumAmount: '总金额',
      cnyRmb: 'CNY人民币',
      usdDollar: 'USD美元',
      chargeDetail: '费用明细',
      applyNo: '申请单号',
      ceibsBankAccount: '中欧银行账户',
      payType: '支付方式',
      bankTransfer: '银行转账',
      cash: '现金支付',
      onlinePay: '在线支付',
      needReceipt: '需要收据',
      pleaseInputReceiptTitle: '请填写收据抬头',
      doSubmit: '提交',
      onlinePaySuccessOrNot: '在线支付是否完成',
      submitSuccess: '申请成功',
      uploadBankTransferVoucher: '上传银行转账凭证',
      checkApplyRecord: '查看申请记录',
      applyAgain: '再次提交申请',
      onlinePayFinished: '已完成',
      onlinePayUnFinished: '未完成',
      bankName: '银行：',
      bankAddress: '地址：',
      bankAccountName: '账户：',
      bankAccountNo: '账号：',
      bankTransferPurpose: '汇款用途：',
      validate: {
        pleaseChoosePayType: '请选择支付方式',
        pleaseInputReceiptTitle: '请填写收据抬头'
      }
    },
    applyList: {
      applyRecord: '申请记录',
      applyNo: '申请单号',
      applyStatus: '申请单状态',
      applyStatusOptions: {
        all: '不限',
        draft: '待提交',
        toBePaid: '待支付',
        certBeingIssued: '文件出具中',
        certIssued: '文件已出具',
        partlyReceived: '部分已领取',
        finished: '已完成',
        cancelled: '已作废',
        notIssued: '无法出具'
      },
      applyType: '申请类型',
      applyTypeOptions: {
        all: '不限',
        paper: '纸质版',
        electronic: '电子版'
      },
      columns: {
        applyNo: '申请单号',
        applyTime: '申请时间',
        applyType: '申请类型',
        chargeAmount: '费用',
        applyStatus: '申请状态',
        payType: '支付方式',
        payStatus: '支付状态',
        operation: '操作'
      },
      payType: {
        cash: '现金支付',
        bankTransfer: '银行转账',
        online: '在线支付'
      },
      payStatus: {
        noNeedConfirm: '无需确认',
        toBeConfirmed: '待确认',
        paid: '已支付',
        failed: '支付失败'
      },
      operations: {
        uploadBankTransferVoucher: '上传转账凭证',
        startOnlinePay: '去支付',
        continueApply: '继续申请',
        cancelApply: '作废',
        checkDetail: '详情',
        downloadElectronicVersionFile: '下载电子版文件',
        unableIssue: '无法出具'
      },
      pleaseUploadBankTransferVoucher: '请上传银行转账凭证，支持常见图片类型(jpg/jpeg/png)',
      uploadSuccess: '上传成功，请耐心等待管理员审核',
      confirmCancelApply: '确认要作废该申请单？',
      confirmCashPay: '确认现金支付',
      confirmUseCashPay: '确认使用现金支付吗？将在您/委托人到校领取时收取。',
      electronicReceiptFile: '电子版收据',
      receiptTitle: '收据抬头',
      receiptFileName: '文件名称',
      receiptFileNotUpload: '暂未上传收据'
    },
    applyDetail: {
      title: '申请详情',
      applyNo: '申请单号：',
      applyTime: '申请日期：',
      applyDetail: '申请明细',
      certType: '文件类型',
      certName: '文件名称',
      copyNumber: '数量',
      operation: '操作',
      downloadElectronicVersionFile: '下载电子版',
      chargeDetail: '计费明细',
      chargeItem: '计费项目',
      chargeItemCount: '计费数量',
      chargeAmount: '金额',
      sumAmount: '总金额',
      chargeCurrency: '结算货币',
      payType: '支付方式',
      payTime: '支付时间',
      bankTransferVoucher: '转账凭证',
      noBankTransferVoucher: '暂未上传转账凭证',
      packageStatusName: '文件袋状态',
      principalName: '委托人',
      principalRelation: '与申请人关系',
      principalMobile: '委托人联系方式',
      receiveTime: '领取时间',
      expectedReceiveTime: '预计领取时间',
      mailStatusName: '快递状态',
      mailTrackingNo: '快递单号',
      mailAreaTypeName: '地址类型',
      mailArea: '国家/地区',
      city: '城市',
      mailZipCode: '邮编',
      mailAddress: '详细地址',
      mailSendTime: '寄出时间',
      packageStatus: {
        draft: '待提交',
        certBeingIssued: '文件出具中',
        certIssued: '文件已出具',
        received: '已领取'
      },
      mailStatus: {
        noNeed: '无需邮寄',
        notSent: '未寄出',
        sent: '已寄出'
      },
      mailAreaType: {
        domestic: '中国大陆',
        international: '海外',
        hkMacaoTw: '港澳台地区'
      },
      mailConsignee: '收件人姓名',
      mailConsigneePhone: '收件人电话',
      mailCompany: '快递公司',
      issuedTime: '出具时间'
    }
  }
}
